import { Badge } from '@crm/ui';
import { Check, ChevronRight } from 'lucide-react';
import { getInitials } from '@/lib/utils';
import { roleLabel } from '../utils';

interface AccountRowProps {
  name: string;
  email: string;
  role: string;
  /** A conta em uso agora - ganha o visto, e nao a seta. */
  atual?: boolean;
  /** Acao propria no lugar do visto, como o botao de trocar. */
  acao?: React.ReactNode;
  /** Sessao viva: entrar nela nao pede senha. */
  conectada?: boolean;
  onClick?: () => void;
}

/**
 * Uma conta em linha: quem e, o email e o perfil, sem abreviar. Clicavel, vira
 * item de lista com a seta a direita - a mesma leitura das outras listas do
 * sistema. Vive no menu do topo, na janela de trocar e na gaveta do celular.
 */
export function AccountRow({
  name,
  email,
  role,
  atual,
  acao,
  conectada,
  onClick,
}: AccountRowProps) {
  const corpo = (
    <>
      <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-primary text-sm font-semibold text-primary-foreground">
        {getInitials(name)}
      </span>

      <span className="min-w-0 flex-1">
        <span className="block truncate text-sm font-medium">{name}</span>
        <span className="block truncate text-xs text-muted-foreground">{email}</span>
        <span className="mt-1 flex flex-wrap items-center gap-1.5">
          <Badge variant="secondary">{roleLabel(role)}</Badge>
          {conectada ? (
            <Badge
              variant="outline"
              className="border-emerald-500/50 text-emerald-700 dark:text-emerald-400"
            >
              Conectada
            </Badge>
          ) : null}
        </span>
      </span>

      {atual && !acao ? (
        <Check className="h-4 w-4 shrink-0 text-primary" aria-label="Conta atual" />
      ) : null}
      {onClick ? <ChevronRight className="h-4 w-4 shrink-0 text-muted-foreground" /> : null}
    </>
  );

  return (
    <div className="flex items-center gap-1 px-4 py-3 transition-colors has-[button:hover]:bg-muted">
      {onClick ? (
        <button
          type="button"
          role="menuitem"
          onClick={onClick}
          className="flex min-w-0 flex-1 items-center gap-3 text-left"
        >
          {corpo}
        </button>
      ) : (
        <div className="flex min-w-0 flex-1 items-center gap-3">{corpo}</div>
      )}

      {acao ? <span className="shrink-0">{acao}</span> : null}
    </div>
  );
}
